import React,{Fragment, useState} from 'react';
import RecordsTable from './recordsTable';
import {useFetch} from '../../lib/useFetch';
import PaginationBar from '../../components/pagination';


const userHeaders = ["User Name", "First", "Last", "email", "Created At"];

const mapResponseData = (data) => {
  const getTrimmedObj = (obj) =>{
    let trimmedObj = {}
    trimmedObj['id'] = obj['_id'];
    // trimmedObj['image'] = userImg;
    trimmedObj['shopper'] = obj.username;
    trimmedObj['firstname'] = obj.firstName;
    trimmedObj['lastnname'] = obj.lastName;
    trimmedObj['email'] = obj.email;
    trimmedObj['createdAt'] = obj.createdAt;
    return trimmedObj;
  }
  if (data){
    return data.map(obj => getTrimmedObj(obj));
  }
  return [];
}

const Users = ({
  openMainModal,
  closeMainModal,
  location
}) => {
  const getRole= ()=>{
    const paths = {
      '/settings':`settings`,
      '/settings/faq':`settings/faq`,
    }
    return paths[location.pathname] || ''
  }
  const [page, setPage] = useState(1);
  const {data, loading, totalCount} = useFetch(`${getRole()}?page=${page}`);
  return(
    <Fragment>
      <RecordsTable
        loading={loading}
        headers={userHeaders}
        records={mapResponseData(data)}
        closeMainModal={closeMainModal}
        openMainModal={openMainModal}
      />
      <PaginationBar page={page} totalCount={totalCount} setPage={setPage}/>
    </Fragment>
  );
}
export default Users;